import { Component, Input, Output, EventEmitter, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Filters } from '@app/@shared/models/reverse-engineering/analysis.models';
import { DatePickerComponent } from '@app/@shared/components/datepicker/datepicker.component';

@Component({
  selector: 'app-search-results-header',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DatePickerComponent],
  templateUrl: './search-results-header.component.html',
  styleUrl: './search-results-header.component.scss',
})
export class SearchResultsHeaderComponent implements OnInit {
  @Input() filters: Filters = {};
  @Input() filterSidebarToggle = signal(true);
  @Input() isMobile$: Observable<boolean>;
  @Input() showSearchResults: boolean = true; // TECH DEBT: Flag for search results visibility
  @Input() initialDateRange?: { from: Date; to: Date };
  @Input() isClearButtonShown: boolean = false;
  @Input() set searchTerm(value: string) {
    this._searchTerm = value;
    if (this.searchForm) {
      this.searchInput.setValue(value, { emitEvent: false });
    }
  }

  @Output() toggleFilters = new EventEmitter<void>();
  @Output() clearFilters = new EventEmitter<void>();
  @Output() submitSearch = new EventEmitter<string>();
  @Output() clearSearch = new EventEmitter<void>();
  @Output() dateRangeChanged = new EventEmitter<{ from: Date; to: Date }>();

  @Input() searchForm: UntypedFormGroup = new UntypedFormGroup({
    searchInput: new UntypedFormControl('', [Validators.required]),
  });
  isFormFocused: boolean = false;

  get hasSearchInput(): boolean {
    return this.searchInputValue?.trim() !== '';
  }
  private _searchTerm = '';

  get searchTerm(): string { return this._searchTerm; }

  ngOnInit() {
    this.searchInput.setValue(this._searchTerm);
  }

  onToggleFilters(): void {
    this.toggleFilters.emit();
  }

  onClearFilters(): void {
    this.clearFilters.emit();
  }

  onSubmitSearch(): void {
    const searchValue = this.searchInputValue;
    if (searchValue?.trim()) {
      this.submitSearch.emit(searchValue);
    } else {
      this.clearSearch.emit();
    }
  }

  onClearSearch(): void {
    this.searchForm.get('searchInput')?.setValue('');
    this.clearSearch.emit();
  }

  onFocusInput(focus: boolean): void {
    this.isFormFocused = focus;
  }

  hasFilters(filters: Filters): boolean {
    if(!filters) {
      return false;
    }

    const keys = Object.keys(filters);

    if(keys.length === 0) {
      return false
    }

    if(keys.length === 1 && keys[0] === 'publishDate') {
      return false;
    }

    return true;

  }

  onDateRangeSelected(dateRange: { from: Date; to: Date }): void {
    this.dateRangeChanged.emit(dateRange);
  }

  get searchInput(): UntypedFormControl {
    return this.searchForm.get('searchInput') as UntypedFormControl;
  }

  get searchInputValue(): string {
    return this.searchForm?.get('searchInput')?.value;
  }
}
